export function toggleObjectFilter(current: { value: string, label: string }[], value: string, checked: boolean, label: string): { value: string, label: string }[] {
  if (!checked) {
    return current.filter(option => option.value !== value)
  }
  if (current.some(option => option.value === value)) {
    return current
  }
  return [...current, { value, label }]
}